import { Link, Outlet } from "react-router-dom";

const ErrorsLayout = () => {
  return (
    <div className="d-flex flex-column flex-root">
      <div className="d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed">
        <div className="d-flex flex-column flex-column-fluid text-center p-10 py-lg-20">
          <a href="/dashboard" className="mb-10 pt-lg-20" data-test-id="error-page__logo-link">
            <img alt="Logo" className="logo-default cpl-brand-logo h-125px d-inline-block" />
          </a>
          <div className="pt-lg-10 mb-10">
            <Outlet />
            <div className="text-center">
              <Link to="/" className="cpl-btn btn-lg cpl-btn-primary" data-test-id="error-page__homepage-link">
                Go to homepage
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export { ErrorsLayout };
